import { isNil, isObject, mapValues } from 'lodash';
import { PublicComp } from 'pages/ValuationsAllocation/types';
import { ParsedPublicCompsValues } from './parsePublicCompsValues.types';

const parsePublicCompsValues = (publicComp: PublicComp): ParsedPublicCompsValues =>
  mapValues(publicComp, field => {
    if (isNil(field)) {
      return null;
    }

    // If it's a CapIQ object, extract its value; otherwise use raw field
    const isCapIqField = isObject(field) && 'value' in field;
    const value = (isCapIqField ? field.value : field) ?? null;

    return value;
  }) as unknown as ParsedPublicCompsValues;

export default parsePublicCompsValues;
